import {
  Menu,
  MenuItem,
  Submenu,
  Table,
  TableColumn,
  Tooltip,
  Popover,
  DatePicker,
  Pagination,
  Carousel,
  CarouselItem,
  Dialog,
  Loading,
  Notification,
  RadioGroup,
  Radio
} from 'element-ui'

import 'element-ui/lib/theme-chalk/tooltip.css'
import 'element-ui/lib/theme-chalk/popover.css'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/icon.css'
import 'element-ui/lib/theme-chalk/date-picker.css'
import 'element-ui/lib/theme-chalk/pagination.css'
import 'element-ui/lib/theme-chalk/carousel.css'
import 'element-ui/lib/theme-chalk/carousel-item.css'
import 'element-ui/lib/theme-chalk/dialog.css'
import 'element-ui/lib/theme-chalk/loading.css'
import 'element-ui/lib/theme-chalk/notification.css'
import 'element-ui/lib/theme-chalk/radio.css'


const ElementUiPlugin = {
  install: (Vue) => {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$loading = Loading.service
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$notify = Notification
    Vue.use(Loading.directive)

    Vue.component(Menu.name, Menu)
    Vue.component(MenuItem.name, MenuItem)
    Vue.component(Submenu.name, Submenu)
    Vue.component(Table.name, Table)
    Vue.component(TableColumn.name, TableColumn)
    Vue.component(Tooltip.name, Tooltip)
    Vue.component(Popover.name, Popover)
    Vue.component(DatePicker.name, DatePicker)
    Vue.component(Pagination.name, Pagination)
    Vue.component(Carousel.name, Carousel)
    Vue.component(CarouselItem.name, CarouselItem)
    Vue.component(Dialog.name, Dialog)
    Vue.component(RadioGroup.name, RadioGroup)
    Vue.component(Radio.name, Radio)
  }
}

export default ElementUiPlugin
